import { fetchHistoryPaymentPosition3 } from '@/api/business/bankstatement'
import { useQuery } from '@tanstack/react-query'

export const BankStatementHistoryPaymentPosition3Keys = {
    all: ['bankstatementhistorypaymentposition3'] as const,
    lists: () => [...BankStatementHistoryPaymentPosition3Keys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...BankStatementHistoryPaymentPosition3Keys.lists(), page, perPage, filters] as const,
    details: () => [...BankStatementHistoryPaymentPosition3Keys.all, 'detail'] as const,
    detail: (params: string) => [...BankStatementHistoryPaymentPosition3Keys.details(), params] as const,
}

export const useBankStatmentHistoryPaymentPosition3Query = ({X_CHAVE, X_TYPE, SK_TEMPO_INICIO, SK_TEMPO_FIM, enableStatus}) => {
    return useQuery({
        enabled: enableStatus,
        queryFn : () => fetchHistoryPaymentPosition3({X_CHAVE, X_TYPE, SK_TEMPO_INICIO, SK_TEMPO_FIM}),
        queryKey: BankStatementHistoryPaymentPosition3Keys.lists(),
    })
}
